import type { IVector3 } from '@seddi/math-v2';
import { type IGarmentProcess, type GarmentGeometrySeamStitch, StitchOrder } from '@seddi/scene';

export class StitchUtils {
  static GetThreadColor(geometry: GarmentGeometrySeamStitch, process: IGarmentProcess): IVector3 {
    const stitchKey = geometry.order === StitchOrder.Primary ? 'stitch' : 'stitchSec';
    const stitch = process[stitchKey]!;
    const isoKey = stitch.kind;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Todo
    const iso = (stitch as any)[isoKey];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Todo
    const thread = iso[geometry.name];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Todo
    const color = thread.color as IVector3;
    return color;
  }
}
